<template>
  <div class="insta"> 
    <a :href="link">   
      <img v-in-viewport.once :src="images.standard_resolution.url" class="rs transition">
      <svg svg-inline="" svg-sprite="" class="insta__icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="#svg-sprite-ed1671b8e3423adf12eb9907b81cf6b2" href="#svg-sprite-ed1671b8e3423adf12eb9907b81cf6b2"></use></svg>
    </a>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none !important;"><symbol id="svg-sprite-ed1671b8e3423adf12eb9907b81cf6b2" viewBox="0 0 14.5 14.5" xmlns="http://www.w3.org/2000/svg"><path d="M11.7 0H2.8C1.3 0 0 1.3 0 2.8v8.9c0 1.5 1.3 2.8 2.8 2.8h8.9c1.5 0 2.8-1.3 2.8-2.8V2.8c0-1.6-1.3-2.8-2.8-2.8zm.9 1.6h.3V4h-2.4V1.6zM7.2 4.8c1.3 0 2.4 1.1 2.4 2.4S8.5 9.6 7.2 9.6 4.8 8.5 4.8 7.2s1.1-2.4 2.4-2.4zm5.7 6.7c0 .8-.6 1.4-1.4 1.4H2.9c-.8 0-1.4-.6-1.4-1.4V5.6h2c-.2.5-.3 1.1-.3 1.6 0 2.2 1.8 4 4 4s4-1.8 4-4c0-.6-.1-1.1-.3-1.6h2z" fill="#fff"/></symbol></svg></div>
</template>

<style lang="scss">
.insta{
  position: relative;
  margin-bottom: 2rem;
  &__icon{
    position: absolute;
    bottom: 5rem;
    right: 5rem;
    width: 26px;
    height: 26px;

    @media #{$bp-sm}{
      bottom: 4rem;
      right: 4rem;
    }
  }
}
</style>

<script>
export default {
  props:[ 'insta' ],
  data() {
    return {
      images: this.insta.images,
      link: this.insta.link
    };
  },
  methods: {
    
  },
  mounted() {

  },
};
</script>
